<template>
    <div>
        <rkm-table
            :items="exames"
            :fields="fields"
            sort-by="exameNome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    color="secondary"
                    small
                    title="Percentual da cota por mês"
                    @click="abrirModal(item)"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalPercentualMensal ref="ModalPercentualMensal" />
    </div>
</template>

<script>
import ModalPercentualMensal from '../ModalPercentualMensal'

export default {
    components: { ModalPercentualMensal },

    props: {
        exames: { required: true, type: Array },
    },

    computed: {
        fields() {
            return [
                { key: 'exameNome', label: 'Exame', sortable: true },
                { key: 'nomeFantasia', label: 'Laboratório', sortable: true },
                { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
                { key: 'cotaNome', label: 'Tipo', class: 'text-center' },
                { key: 'inicio', label: 'Início', class: 'text-center' },
                { key: 'fim', label: 'Fim', class: 'text-center' },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ]
        },
    },

    methods: {
        abrirModal(item) {
            const local = [item.nomeFantasia, item.infraestruturaNome].filter(Boolean).join(' / ')

            this.$refs.ModalPercentualMensal.open(item, `App ConectaSUS - Cidadão ${item.exameNome} - ${local}`)
        },
    },
}
</script>
